import CreateResourceInteractor from "../../../core/interactor/app/crud/CreateResourceInteractor";
import Constants from "../../common/Constants";
import { IAttachment } from "../../model/Attachment";
import AttachmentMapper from "../../service/AttachmentMapper";
import AttachmentParamMapper from "../../service/AttachmentParamMapper";

export default class CreateAttachmentInteractor {
  private createResource: CreateResourceInteractor<IAttachment>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(
    model: IAttachment,
    caseLawDocumentId?: number,
    caseDecisionId?: string,
    legalViewId?: number
  ) {
    if (caseDecisionId) {
      return this.createResource.execute(
        `case-decisions/${caseDecisionId}/${Constants.attachmentPath}`,
        AttachmentMapper,
        AttachmentParamMapper,
        model
      );
    } else if (legalViewId) {
      return this.createResource.execute(
        `${Constants.legalViewPath}/${legalViewId}/${Constants.attachmentPath}`,
        AttachmentMapper,
        AttachmentParamMapper,
        model
      );
    }
    return this.createResource.execute(
      `${Constants.endpointBasePath}/${caseLawDocumentId}/${Constants.attachmentPath}`,
      AttachmentMapper,
      AttachmentParamMapper,
      model
    );
  }
}
